import { initializeApp } from "firebase/app";
import { getFirestore, collection, onSnapshot, doc, orderBy, query } from 'firebase/firestore'
import { getFunctions, httpsCallable } from "firebase/functions";
import controls from "./controls"
import { getAuth } from "firebase/auth";
import { showSnackbar } from "./Snackbar";

const firebaseConfig = {
    apiKey: "AIzaSyDcREtwTpF5RUE7-3Top67i5dXY6ltB-eQ",
    authDomain: "frecall-a0b07.firebaseapp.com",
    projectId: "frecall-a0b07",
    storageBucket: "frecall-a0b07.appspot.com",
    messagingSenderId: "446467769626",
    appId: "1:446467769626:web:9836e247e29e8cf83c58a3",
    measurementId: "G-VR8RSGYYF5"
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);


function getUsersOnCall(handleUserChange) {

    const referenceId = controls.roomId;
    const subscribeLegacy = (consumer = handleUserChange) => {
      const usersOnCallCollection = collection(db, "usersOnCall");
      const usersOnCallReference = doc(usersOnCallCollection, `${referenceId}`);
      return onSnapshot(usersOnCallReference, function(snapshot) {
        consumer(snapshot.data() || {});
      }, () => {
        showSnackbar("Queue updates are temporarily unavailable. Reconnecting...", "warning");
      });
    };

    if (Number(controls.queueSchemaVersion || 1) < 2) {
      return subscribeLegacy();
    }

    let fallbackUnsubscribe;
    let shadowUnsubscribe;
    let v2Queue;
    let legacyQueue;
    const emitQueue = () => {
      if (!v2Queue) return;
      if (Number(controls.queueSchemaVersion) !== 2 || !legacyQueue) {
        handleUserChange(v2Queue);
        return;
      }
      const v2Ids = v2Queue.usersOnQueue || [];
      const legacyIds = legacyQueue.usersOnQueue || [];
      const matches = v2Ids.length === legacyIds.length &&
        v2Ids.every((id, index) => id === legacyIds[index] &&
          String(v2Queue[id] || "") === String(legacyQueue[id] || ""));
      handleUserChange(matches ? v2Queue : legacyQueue);
    };
    if (Number(controls.queueSchemaVersion) === 2) {
      shadowUnsubscribe = subscribeLegacy((queue) => {
        legacyQueue = queue;
        emitQueue();
      });
    }
    const entries = query(
      collection(db, "callQueues", referenceId, "entries"),
      orderBy("timeRing", "asc"),
    );
    const unsubscribe = onSnapshot(entries, (snapshot) => {
      const queue = {usersOnQueue: []};
      snapshot.docs.forEach((entrySnapshot) => {
        const entry = entrySnapshot.data() || {};
        const callerId = String(entry.callerId || "");
        if (!callerId) return;
        queue.usersOnQueue.push(callerId);
        queue[callerId] = entry.assignedAgentName || "";
        queue[`${callerId}-callLogId`] = entry.historyDocId || entrySnapshot.id;
        queue[`${callerId}-liveKitRoom`] = entry.liveKitRoomName || "";
        queue[`${callerId}-timeRing`] = Number(entry.timeRing || 0);
        queue[`${callerId}-timeAnswered`] = Number(entry.timeAnswered || 0);
        queue[`${callerId}-audioBitrateKbps`] =
          Number(entry.audioBitrateKbps || 48);
        if (entry.transfer) queue[`${callerId}-queue`] = entry.transfer;
      });
      v2Queue = queue;
      emitQueue();
    }, () => {
      showSnackbar("Using the backup queue connection while updates recover.", "warning");
      if (!fallbackUnsubscribe) fallbackUnsubscribe = subscribeLegacy();
    });
    return () => {
      unsubscribe();
      fallbackUnsubscribe?.();
      shadowUnsubscribe?.();
    };
  }

async function setLiveKitToken(){
  const functions = getFunctions();
  controls.token = "";

  if((controls.livekitUrl || "").length < 2){
    const allowed = await getRoomDetails();
    // console.log({allowed});
    if (!allowed) return false;
  }

  // console.log("TTTTTTTTTT");

  const createLiveKitToken = httpsCallable(functions, 'createLiveKitToken');
  try{
   await createLiveKitToken({
    roomId: controls.roomId,
    roomName: controls.mediaRoomName || controls.channelName,
    participantName: `agent-${controls.agentUserId || controls.channelName}`,
    roomAdmin: true,
    agentEmail: auth.currentUser?.email || "",
   }).then((result)=>{
    if(!result.data?.token) return;
    controls.token = result.data.token;
    controls.livekitUrl = result.data.url || controls.livekitUrl;
  })
  return controls.token.length > 1;
  
  } catch(err){
    // console.log("EEEEEERRR",err)
    return false;
  }

}

async function getRoomDetails() {
    const functions = getFunctions();

    const getRoomDetails = httpsCallable(functions, 'getRoomDetails');

    let allowed = false;

    try{
      await getRoomDetails({"roomId": controls.roomId,"agentName": controls.channelName, "email": auth.currentUser?.email || ""}).then((result)=>{
      if(!result.data){
        showSnackbar("Call room details are unavailable right now.", "warning");
        return;
      }
      // console.log("RRRRRRR", auth.currentUser.uid,", ", controls.channelName);

      if(result.data.allowed){
        
      controls.livekitUrl = result.data.livekitUrl;
      controls.rooms = result.data.rooms;
      controls.queueSchemaVersion = Number(
        result.data.queueSchemaVersion || 1,
      );
      allowed = true;
      } else {
        showSnackbar("You are not yet authorised as an agent in this call room, please contact your manager.", "error")
      }
    })

    return allowed;

    } catch(err){
      // console.log("EEEEEERRR",err)
      return null;
    }
}

async function updateAgentActivityState(state) {
  if (!controls.roomId || !auth.currentUser) return null;
  const functions = getFunctions();
  const setAgentActivityState = httpsCallable(
      functions,
      "setAgentActivityState",
  );
  const result = await setAgentActivityState({
    roomId: controls.roomId,
    state,
  });
  const response = result.data || {};
  controls.agentActivityState = response.state || state;
  return response;
}

export default db;
export {
  auth,
  getRoomDetails,
  getUsersOnCall,
  setLiveKitToken,
  updateAgentActivityState,
};
